/* ============================================================
   ORO COSMOS — animated starfield canvas
   ============================================================
   Lightweight performant starfield with twinkling stars,
   plus parallax on scroll. Respects reduced motion.
   ============================================================ */

(function () {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    var canvas = document.getElementById('oro-starfield');
    if (!canvas) return;

    var section = document.querySelector('.oro-gf');
    if (!section) return;

    var prefersReduced = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var width = 0, height = 0;
    var stars = [];
    var animId = null;

    var STAR_COUNT_BASE = 140;
    var STAR_COUNT = STAR_COUNT_BASE;

    function resize() {
      var rect = section.getBoundingClientRect();
      width  = section.offsetWidth;
      height = section.offsetHeight;
      canvas.width  = Math.floor(width * dpr);
      canvas.height = Math.floor(height * dpr);
      canvas.style.width  = width + 'px';
      canvas.style.height = height + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      // Adjust density based on viewport (mobile gets fewer for perf)
      var isSmall = width < 700;
      STAR_COUNT = isSmall ? Math.floor(STAR_COUNT_BASE * 0.5) : STAR_COUNT_BASE;
      seed();
    }

    function seed() {
      stars = [];
      for (var i = 0; i < STAR_COUNT; i++) {
        // Layered: most stars are tiny background; a few are big foreground
        var depth = Math.random();
        var radius;
        var brightness;
        if (depth < 0.7) {
          radius = Math.random() * 0.7 + 0.2;
          brightness = Math.random() * 0.4 + 0.2;
        } else if (depth < 0.95) {
          radius = Math.random() * 1.0 + 0.6;
          brightness = Math.random() * 0.3 + 0.5;
        } else {
          radius = Math.random() * 1.5 + 1.0;
          brightness = Math.random() * 0.3 + 0.7;
        }

        // Hue: most stars white-ish, some gold-tinted, some blue-tinted
        var hue = Math.random();
        var color;
        if (hue < 0.55) color = [168, 138, 61];      // olive gold
        else if (hue < 0.85) color = [184, 160, 101]; // light olive gold
        else color = [15, 29, 58];                    // navy accent

        stars.push({
          x: Math.random() * width,
          y: Math.random() * height,
          r: radius,
          b: brightness,
          color: color,
          phase: Math.random() * Math.PI * 2,
          speed: 0.0005 + Math.random() * 0.0015,
          twinkleAmp: 0.3 + Math.random() * 0.4,
          // gentle parallax-like drift
          vx: (Math.random() - 0.5) * 0.02,
          vy: (Math.random() - 0.5) * 0.02
        });
      }
    }

    function draw(ts) {
      ctx.clearRect(0, 0, width, height);

      var t = ts || 0;
      for (var i = 0; i < stars.length; i++) {
        var s = stars[i];
        // Drift
        s.x += s.vx;
        s.y += s.vy;
        if (s.x < -10) s.x = width + 10;
        if (s.x > width + 10) s.x = -10;
        if (s.y < -10) s.y = height + 10;
        if (s.y > height + 10) s.y = -10;

        // Twinkle
        var twinkle = Math.sin(t * s.speed + s.phase) * s.twinkleAmp + 1;
        var alpha = Math.max(0, Math.min(1, s.b * twinkle));

        // Halo for bigger stars
        if (s.r > 0.9) {
          var grad = ctx.createRadialGradient(s.x, s.y, 0, s.x, s.y, s.r * 4);
          grad.addColorStop(0, 'rgba(' + s.color[0] + ',' + s.color[1] + ',' + s.color[2] + ',' + (alpha * 0.4) + ')');
          grad.addColorStop(1, 'rgba(' + s.color[0] + ',' + s.color[1] + ',' + s.color[2] + ',0)');
          ctx.fillStyle = grad;
          ctx.beginPath();
          ctx.arc(s.x, s.y, s.r * 4, 0, Math.PI * 2);
          ctx.fill();
        }

        ctx.fillStyle = 'rgba(' + s.color[0] + ',' + s.color[1] + ',' + s.color[2] + ',' + alpha + ')';
        ctx.beginPath();
        ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
        ctx.fill();
      }

      animId = requestAnimationFrame(draw);
    }

    function drawStatic() {
      // Static one-time render for reduced motion users
      ctx.clearRect(0, 0, width, height);
      for (var i = 0; i < stars.length; i++) {
        var s = stars[i];
        ctx.fillStyle = 'rgba(' + s.color[0] + ',' + s.color[1] + ',' + s.color[2] + ',' + s.b + ')';
        ctx.beginPath();
        ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
        ctx.fill();
      }
    }

    // ---- Setup + lifecycle ----
    resize();

    if (prefersReduced) {
      drawStatic();
    } else {
      animId = requestAnimationFrame(draw);
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        resize();
        if (prefersReduced) drawStatic();
      }, 200);
    });

    // Pause animation when section is off-screen for performance
    if ('IntersectionObserver' in window && !prefersReduced) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !animId) {
            animId = requestAnimationFrame(draw);
          } else if (!entry.isIntersecting && animId) {
            cancelAnimationFrame(animId);
            animId = null;
          }
        });
      });
      io.observe(section);
    }
  }
})();
